import React from 'react';
import styles from './pmndp-enhanced.module.css';

const PMNDPModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer,
  size = 'medium',
  icon
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    small: { width: '400px' },
    medium: { width: '600px' },
    large: { width: '800px' },
    xlarge: { width: '1000px' }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles['pmndp-modal-overlay']} onClick={handleOverlayClick}>
      <div className={styles['pmndp-modal']} style={sizeClasses[size]}>
        <div className={styles['pmndp-modal-header']}>
          <h2 className={styles['pmndp-modal-title']}>
            {icon && <i className={`fa ${icon}`}></i>}
            {title}
          </h2>
          <button className={styles['pmndp-modal-close']} onClick={onClose}>
            <i className="fa fa-times"></i>
          </button>
        </div>
        
        <div className={styles['pmndp-modal-body']}>
          {children}
        </div>
        
        {footer && (
          <div className={styles['pmndp-modal-footer']}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default PMNDPModal;
